import { useGameStore } from '../stores/gameStore'

export default function HUD() {
  const { timer, stability, squad, players, mySessionId, selectedRole } = useGameStore()

  const formatTime = (seconds: number): string => {
    const mins = Math.floor(seconds / 60)
    const secs = seconds % 60
    return `${mins}:${secs.toString().padStart(2, '0')}`
  }

  const playerList = Object.values(players)

  return (
    <div className="absolute inset-x-0 top-0 p-4 pointer-events-none z-40">
      <div className="flex items-start justify-between">
        {/* Left: Timer and stability */}
        <div className="bg-gray-900/80 rounded-lg p-3 pointer-events-auto">
          <div className="flex items-center gap-4">
            {/* Timer */}
            <div className="text-center">
              <div className="text-xs text-gray-400">Czas</div>
              <div className="text-2xl font-mono text-emerald-neon">
                {formatTime(timer)}
              </div>
            </div>

            {/* Stability bar */}
            <div className="w-32">
              <div className="text-xs text-gray-400 mb-1">Stabilnosc</div>
              <div className="h-3 bg-gray-700 rounded-full overflow-hidden">
                <div
                  className={`h-full transition-all duration-500 ${
                    stability > 50 ? 'bg-emerald-neon' : stability > 25 ? 'bg-yellow-500' : 'bg-red-500'
                  }`}
                  style={{ width: `${stability}%` }}
                />
              </div>
              <div className="text-xs text-right text-gray-500 mt-0.5">
                {stability}%
              </div>
            </div>

            {/* Squad type */}
            <div className="text-center">
              <div className="text-xs text-gray-400">Sklad</div>
              <div className="text-sm text-white capitalize">{squad}</div>
            </div>
          </div>
        </div>

        {/* Center: Role indicator */}
        <div
          className="bg-gray-900/80 rounded-lg px-4 py-2 pointer-events-auto"
          style={{ borderColor: getRoleColor(selectedRole), borderWidth: 2 }}
        >
          <div className="text-xs text-gray-400">Twoja rola</div>
          <div className="font-bold" style={{ color: getRoleColor(selectedRole) }}>
            {selectedRole.toUpperCase()}
          </div>
        </div>

        {/* Right: Players */}
        <div className="bg-gray-900/80 rounded-lg p-3 pointer-events-auto">
          <div className="text-xs text-gray-400 mb-2">Gracze</div>
          <div className="flex gap-2">
            {playerList.map((player) => (
              <div
                key={player.sessionId}
                className={`w-8 h-8 rounded flex items-center justify-center font-bold text-xs
                  ${player.sessionId === mySessionId ? 'ring-2 ring-white' : ''}`}
                style={{ backgroundColor: getRoleColor(player.role) }}
                title={`${player.nickname} (${player.role.toUpperCase()})`}
              >
                {player.role.charAt(0).toUpperCase()}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom: Controls hint */}
      <div className="absolute bottom-4 left-4 bg-gray-900/60 rounded px-3 py-2 text-xs text-gray-400">
        WASD lub strzalki - ruch
      </div>
    </div>
  )
}

function getRoleColor(role: string): string {
  const colors: Record<string, string> = {
    flux: '#00FF66',
    logic: '#4488FF',
    spark: '#FF8844',
    echo: '#AA44FF',
  }
  return colors[role] || '#ffffff'
}
